import Vue from 'vue'
import bevent from './events.js'

(function() {
  function install(Vue) {
    let on = (...arg) => {
      bevent.$on.call( bevent ,...arg)
    }

    let emit = (...arg) => {
      bevent.$emit.call( bevent ,...arg)
    }
    Vue.mixin({
      created: function() {
        this._on = on
        this._emit = emit
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = install
  } else if (typeof define == "function" && define.amd) {
    define([], function() {
      return install
    })
  } else if (window.Vue) {
    Vue.use(install)
  }

})()



// WEBPACK FOOTER //
// ./static/plugins/events/index.js